import { addMethod, string } from "yup";

export const overrideYupEmail = () => {
    const emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; /* https://emailregex.com/ */

    addMethod(string, "email", function validateEmail(message) {
        return this.matches(emailRegex, {
            message,
            name: "email",
            excludeEmptyString: true,
        });
    });
};
